import {ApiResponse} from "../models/api-response.model";
import {ProformaModel} from "../models/proforma.model";
import {ProformaLong} from "../models/proforma-long-response.model";
import {apiGet, apiPost, apiPut, buildPaginatedUrl} from '../utils/api.util';
import {PaginationParams} from "../models/pagination.model";


export interface ProformaShortResponse {
    id: number
    referenceNumber: string
}

export enum ProformaActionType {
    APPROVE = 'APPROVE',
    REJECT = 'REJECT',
    PAY = 'PAY'
}

export interface ProformaActionRequest {
    approvableIds: number[]
    actionType: ProformaActionType
    receiptNumber?: string
    receipt?: string // Base64 encoded byte array
}

export const createProforma = async (proforma: ProformaModel): Promise<ApiResponse<ProformaShortResponse>> => {
    const response = await apiPost('/api/v1/pm/proforma', proforma, {});
    return await response.json();
};

export const updateProforma = async (id: number, proforma: ProformaModel): Promise<ApiResponse<ProformaShortResponse>> => {
    const response = await apiPut(`/api/v1/pm/proforma/${id}`, proforma, {});
    return await response.json();
};

export const getProformaById = async (id: number): Promise<ApiResponse<ProformaLong>> => {
    const response = await apiGet(`/api/v1/pm/proforma/${id}`);
    return await response.json();
};

export const getProformasForEmployee = async (employeeId: number, projectId?: number, params?: PaginationParams): Promise<ApiResponse<ProformaLong[]>> => {
    const baseUrl = projectId
        ? `/api/v1/pm/proforma/for-employee/${employeeId}?projectId=${projectId}`
        : `/api/v1/pm/proforma/for-employee/${employeeId}`;

    const response = await apiGet(buildPaginatedUrl(baseUrl, params));
    return await response.json();
};

export const printProforma = async (proformaId: number): Promise<Blob> => {
    const response = await apiGet(`/api/v1/pm/proforma/${proformaId}/print`);
    return await response.blob();
};

export const previewProforma = async (proformaId: number) : Promise<Blob> => {
    const response = await apiGet(`/api/v1/pm/proforma/${proformaId}/preview`);
    return await response.blob();
}

export const loadPendingProformas = async (params?: PaginationParams): Promise<ApiResponse<ProformaLong[]>> => {
    const response = await apiGet(buildPaginatedUrl(`/api/v1/pm/proforma/pending`, params));
    return await response.json();
};

export const loadProformasForCurrentCompany = async (params?: PaginationParams): Promise<ApiResponse<ProformaLong[]>> => {
    const response = await apiGet(buildPaginatedUrl(`/api/v1/pm/proforma/for-current-company`, params));
    return await response.json();
};

export const applyActionToProformas = async (actionRequest: ProformaActionRequest): Promise<ApiResponse<ProformaLong[]>> => {
    const response = await apiPut('/api/v1/pm/proforma/apply-action', actionRequest,{});
    return await response.json();
}

export const submitProformasForApproval = async (proformaIds: number[]): Promise<ApiResponse<ProformaShortResponse[]>> => {
    const response = await apiPost('/api/v1/pm/proforma/submit-for-approval', proformaIds, {});
    return await response.json();
}